/**
 * @file Time.jsx
 * @exports Time
 */
import React from 'react'
const blue = '#50b0ff'

const defaultColor = blue

const Time = ({ style }) => (
  <svg
    id='time-icon'
    preserveAspectRatio='xMidYMid meet'
    style={style}
    viewBox='0 0 20 40'
  >
    <description>hourglass icon</description>
    <title>time</title>
    <path
      fill={defaultColor}
      d='M 13.9,15.6 H 2.2 c -0.5,0 -0.8,0.4 -0.8,0.9 v 0.6 c 0,0.5 0.4,0.9 0.8,0.9 0,3.6 1.8,6.6 4.2,7.6 -2.4,1 -4.2,4 -4.2,7.6 -0.5,0 -0.8,0.4 -0.8,0.9 v 0.6 c 0,0.5 0.4,0.9 0.8,0.9 h 11.6 c 0.5,0 0.8,-0.4 0.8,-0.9 v -0.6 c 0,-0.5 -0.4,-0.9 -0.8,-0.9 0,-3.6 -1.8,-6.6 -4.2,-7.6 2.4,-1 4.2,-4 4.2,-7.6 0.5,0 0.8,-0.4 0.8,-0.9 v -0.6 c 0.1,-0.4 -0.3,-0.9 -0.7,-0.9 z M 11.4,31.1 H 4.7 C 5.3,29 6.6,27.5 8,27.5 c 1.5,0 2.8,1.5 3.4,3.6 z M 11,20.4 H 5.1 C 4.9,19.7 4.7,18.9 4.7,18 h 6.7 c 0,0.8 -0.1,1.7 -0.4,2.4 z'
    />
  </svg>
)

export default Time
